{
  "familyId": "SWW-TT-INV-TRICK",
  "questions": [
    {
      "id": "SWW-TT-INV-TRICK-001",
      "familyId": "SWW-TT-INV-TRICK",
      "module": "SpellingWW",
      "tier": 12,
      "levelCode": "E7+",
      "group": 7,
      "skill": "tegenwoordige_tijd",
      "subSkill": "tt_inversie_complex",
      "questionType": "multiple_choice",
      "question": "Welke spelling is juist? '... jij ook mee naar het feest?'",
      "context": null,
      "options": ["Ga", "Gaat", "Gaan", "Ging"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [{ "type": "rule", "data": { "title": "Inversie Regel", "content": "Inversie geldt ALLEEN bij jij/je. Bij 'Ga jij?' gebruik je de stam. Bij 'Gaat hij?' blijft de -t staan.", "icon": "lightbulb" }, "showWhen": "wrong" }],
      "conceptId": "dt_inversion_rule",
      "variantIndex": 1,
      "feedback": {
        "explanationText": "Regel: inversieregel. Stap 1: Bij inversie staat 'jij' ACHTER het werkwoord. Stap 2: Dan valt de -t weg: gebruik alleen de stam. Stap 3: De stam van 'gaan' is 'ga'. Dus: 'Ga jij?' (niet 'Gaat jij?'). Let op: dit geldt ALLEEN voor jij/je. Bij hij blijft de -t staan: 'Gaat hij?' Checkstrategie: draai de zin om — 'Jij gaat' → 'Ga jij?' (t valt weg).",
        "distractorExplanations": {
          "0": "Correct! Inversieregel: bij inversie met 'jij' gebruik je de stam zonder -t: Ga jij?",
          "1": "Veelgemaakte fout: de -t laten staan bij inversie met jij. 'Gaat' is de gewone jij-vorm ('Jij gaat'), maar bij inversie valt de -t weg: 'Ga jij?' Misconceptie: vergeten dat inversie de -t laat wegvallen bij jij.",
          "2": "Veelgemaakte fout: het hele werkwoord gebruiken. 'Gaan' is het hele werkwoord. Bij inversie gebruik je de stam: ga (niet gaan). Misconceptie: het hele werkwoord verwarren met de stam.",
          "3": "Veelgemaakte fout: verleden tijd gebruiken. 'Ging' is de verleden tijd. De zin gaat over het heden/toekomst ('naar het feest'), dus tegenwoordige tijd: ga."
        }
      }
    }
  ]
}